module.exports = __webpack_public_path__ + "static/epitome-ayaka-722f6ff8fea91b60f04c64eb8ec5e268.png";